import { Login } from "./login/Login";
import { Logout } from "./logout/Logout";
import { LogoutSilent } from "./logout/LogoutSilent";
import { PasswordChange } from "./passwordChange/PasswordChange";
import { PasswordRecovery } from "./passwordRecovery/PasswordRecovery";
import { PasswordReset } from "./passwordRecovery/PasswordReset";
import { Activate } from "./register/Activate";
import { ResendActivationEmail } from "./resendactivationemail/ResendActivationEmail";
import { FileRedirect } from "./fileRedirect/FileRedirect";

export const Auth = {
    Login,
    Logout,
    LogoutSilent,
    PasswordChange,
    PasswordRecovery,
    PasswordReset,
    Activate,
    ResendActivationEmail,
    FileRedirect
};
